import React, { useState, useEffect, useRef } from "react";
import * as Const from "./../_Const";

const AutoFitText = ({
  prefix = "",
  part1 = "",
  part2 = "",
  postfix = "",
  px = 16,
  className = "",
  justify = "justify-center",
  prefixCss = "",
  part1Css = "",
  part2Css = "",
  postfixCss = "",
  gapX = "",
}) => {
  const containerRef = useRef(null);
  const [fontSize, setFontSize] = useState(10);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const fitText = () => {
      let min = 10;
      let max = 500; // Maximální možná velikost v px
      let optimal = min;

      // Výpočet dostupného prostoru
      const availableWidth = container.clientWidth - px * 2;
      const availableHeight = container.clientHeight;

      // Pomocný prvek pro měření (vytvořen mimo viditelnou část)
      const span = document.createElement("span");
      span.style.visibility = "hidden";
      span.style.position = "absolute";
      span.style.whiteSpace = "nowrap";
      span.style.fontFamily = window.getComputedStyle(container).fontFamily;
      span.style.fontWeight = window.getComputedStyle(container).fontWeight;
      document.body.appendChild(span);

      // Binární vyhledávání ideální velikosti
      while (min <= max) {
        let mid = Math.floor((min + max) / 2);
        const smallSize = mid * 0.6; // Prefix/Postfix má 60% velikost

        // Simulace obsahu v měřícím prvku (včetně mezer)
        // Používáme flex-gap simulaci pomocí marginu pro přesné měření
        const gap = mid * 0.8; // Odpovídá gap-x-[0.5em]

        let contentHtml = "";
        if (prefix) contentHtml += `<span style="font-size: ${smallSize}px">${prefix}</span><span style="display:inline-block; width:${gap}px"></span>`;
        contentHtml += `<span style="font-size: ${mid}px">${part1}${part2}</span>`;
        if (postfix) contentHtml += `<span style="display:inline-block; width:${gap}px"></span><span style="font-size: ${smallSize}px">${postfix}</span>`;

        span.innerHTML = contentHtml;

        if (span.offsetWidth <= availableWidth && span.offsetHeight <= availableHeight) {
          optimal = mid;
          min = mid + 1;
        } else {
          max = mid - 1;
        }
      }

      document.body.removeChild(span);
      setFontSize(optimal);
    };

    // Spuštění výpočtu
    fitText();

    // Reagovat na změnu velikosti okna
    const resizeObserver = new ResizeObserver(() => fitText());
    resizeObserver.observe(container);

    return () => resizeObserver.disconnect();
  }, [prefix, part1, part2, postfix, px]);

  return (
    <div
      ref={containerRef}
      className={`w-full h-full flex items-center overflow-hidden ${className} ${justify}`}
      style={{
        paddingLeft: `${px}px`,
        paddingRight: `${px}px`,
        lineHeight: "1",
      }}
    >
      <div className={`whitespace-nowrap flex items-baseline ${gapX}`} style={{ willChange: "font-size" }}>
        {prefix && (
          <span style={{ fontSize: `${fontSize * 0.6}px` }} className={`${prefixCss} opacity-80 transition-alla`}>
            {prefix}
          </span>
        )}

        {/* <span style={{ fontSize: `${fontSize}px` }} className="transition-all">
          {part1}
          {part2}
        </span> */}

        {/* Rozdělení part1 a part2 do samostatných spanů zajistí, že gap-x mezi ně vloží mezeru */}
        <span className={`${part1Css}`} style={{ fontSize: `${fontSize}px` }}>
          {part1}
        </span>
        <span className={`${part2Css}`} style={{ fontSize: `${fontSize}px` }}>
          {part2}
        </span>

        {postfix && (
          <span style={{ fontSize: `${fontSize * 0.6}px` }} className={`${postfixCss} opacity-80 transition-alla`}>
            {postfix}
          </span>
        )}
      </div>
    </div>
  );
};

export default AutoFitText;
